import React, { useEffect, useState } from "react";
import { addPg, getPgDetails, getPgDetailsByOwner } from "./apiService";
import { useAuth } from "./auth";
import { useNavigate } from "react-router-dom";

const NewPG = () => {
  const [pgname, setPgname] = useState("");
  const [rooms, setRooms] = useState("");
  const [errors, setErrors] = useState({});
  const [pgdetails, setPgdetails] = useState([]);
  const { userid } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    getPgDetailsByOwner(userid)
      .then((res) => {
        setPgdetails(res);
      })
      .catch((e) => console.log(e));
  }, []);

  // console.log(userid);

  const handlePgSubmit = () => {
    let errors = {};
    if (!pgname) errors.pgname = "PG name is required";
    if (!rooms) errors.rooms = "Enter valid no here";

    pgdetails.forEach((pg) => {
      if (pg.pgname === pgname) {
        errors.pgname = "pg name already taken";
        // console.log(errors.username);
      }
      return errors;
    });

    setErrors(errors);

    if (Object.keys(errors).length === 0) {
      const pg = {
        pgname: pgname,
        rooms: rooms,
        owner: userid,
      };
      // setUser(user1);

      addPg(pg);

      setPgname("");
      setRooms("");
      navigate("/Dashboard");
    }
  };
  return (
    <div className="container">
      <div className="header">NewPG</div>
      <div className="label">
        PGName:
        <input
          type="text"
          className="inputbox"
          name="pgname"
          value={pgname}
          onChange={(e) => setPgname(e.target.value)}
        />
        {errors.pgname ? (
          <div className="errortext">{errors.pgname}</div>
        ) : null}
      </div>

      <div className="label">
        No.of Rooms:
        <input
          type="text"
          className="inputbox"
          name="rooms"
          value={rooms}
          onChange={(e) => setRooms(e.target.value)}
        />
        {errors.rooms ? <div className="errortext">{errors.rooms}</div> : null}
      </div>
      <input
        type="submit"
        className="btn-cls"
        value="Submit"
        onClick={handlePgSubmit}
      />
    </div>
  );
};

export default NewPG;
